import { render, staticRenderFns } from "./paakayttaja.vue?vue&type=template&id=a677bdf4&scoped=true&"
import script from "./paakayttaja.vue?vue&type=script&lang=ts&"
export * from "./paakayttaja.vue?vue&type=script&lang=ts&"
import style0 from "./paakayttaja.vue?vue&type=style&index=0&id=a677bdf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a677bdf4",
  null
  
)

export default component.exports